// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2pUWM","col":"styles_col__RHkvR"};